import React, { useCallback } from 'react';

/**
 * Custom hook for on-visible facility handler.
 * @param {Object} options
 * @param {Function} [options.onVisible] - Visibility callback
 * @param {Object} options.facility - Facility data
 * @param {number} [options.percentVisible=70] - Visibility threshold percentage
 * @returns {{ onVisible: Function }}
 */
export const useOnVisibleFacilityHandler = ({
	onVisible: onVisibleProp,
	facility,
	percentVisible = 70,
}) => {
	const onVisible = useCallback(
		(delay) => {
			if (typeof onVisibleProp !== 'undefined') {
				onVisibleProp({
					facility_id: facility.id,
					visible_threshold: percentVisible,
					index: facility.index,
					rank: facility.position,
					in_network: facility.inNetwork,
					has_scarcity: facility.hasScarcity,
					delay,
					cardType: facility.cardType,
				});
			}
		},
		[onVisibleProp, facility, percentVisible],
	);

	return { onVisible };
};

function withOnVisibleFacilityHandler(WrappedComponent) {
	const WithOnVisibleFacilityHandler = (props) => {
		const hookResult = useOnVisibleFacilityHandler(props);
		return (
			<WrappedComponent
				{...props}
				{...hookResult}
			/>
		);
	};
	WithOnVisibleFacilityHandler.displayName = `withOnVisibleFacilityHandler(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WithOnVisibleFacilityHandler;
}

export default withOnVisibleFacilityHandler;
